import { auth } from '../../utils/auth';
import { Body } from '../../components/Typography';
import { FormattedMessage } from 'react-intl';
import { SignupUrlKeys } from '../../types/signup/common';
import { useEffect } from 'react';

function LoginRedirect() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get(SignupUrlKeys.REDIRECT_URL);
    auth.login(redirectUrl);
  }, []);

  return (
    <Body>
      <FormattedMessage id={'loginRedirect.message'} />
    </Body>
  );
}

export default LoginRedirect;
